<!--
@component

This component is a login/register form for firebase.
Supports google signin too
-->

<script lang="ts">
    import {auth, functions, googleAuth} from "../services/firebase";
    import {fade, slide} from "svelte/transition"
    import ErrorAlert from "./ErrorAlert.svelte";
    import {createEventDispatcher} from "svelte";

    export let authMode: "login" | "register" = "register";
    let isAuthenticated = false;
    let loading = false;
    let err: string | null = "";
    const d = createEventDispatcher();
    let precertified = false;
    let precertEmail = "";
    let precheckError = "";
    let isRegister = false;
    auth.onAuthStateChanged(user => {
        isAuthenticated = !!user;

        if (user && !isRegister) {
            d("auth")
        }
    })

    function login() {
        const email = (document.getElementById("l-email") as HTMLInputElement).value
        const password = (document.getElementById("l-password") as HTMLInputElement).value

        if (!email || !password) {
            err = "Fill out all fields!"
            return;
        }
        err = "";
        loading = true;
        auth.signInWithEmailAndPassword(email, password).then(async () => {
            await waitForClaims();
            loading = false;
        }).catch(e => {
            err = `(${e.code}) ${e.message}`
        })
    }
    
    function register() {
        const email = (document.getElementById("r-email") as HTMLInputElement).value
        const password = (document.getElementById("r-password") as HTMLInputElement).value
        const cpassword = (document.getElementById("r-cpassword") as HTMLInputElement).value

        if (!email || !password || !cpassword) {
            err = "Fill out all fields!"
            return;
        }
        if (password !== cpassword) {
            err = "Passwords don't match!"
            return;
        }
        err = "";
        isRegister = true;
        loading = true;
        auth.createUserWithEmailAndPassword(email, password).then(async () => 
        {
            await waitForClaims();
        }
        ).catch(e => {
            err = `(${e.code}) ${e.message}`
        }).finally(()=>{
            loading = false;
        })
    }

    function google() {
        loading = true;
        auth.signInWithPopup(googleAuth).then(async (user) => {
            await waitForClaims();
        }).catch(e => {
            err = `(${e.code}) ${e.message}`
        }).finally(()=>{
            loading = false;
        })
    }
    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function checkPrecertification(){
        // functions.useEmulator("localhost", 5001)
        try {
            loading = true;
            const precertCall = await functions.httpsCallable("checkPrecertification")({
                email: precertEmail,
            });
            loading = false;
            console.log(precertCall.data)
            if(precertCall.data){
                if(precertCall.data.error){
                    precheckError = precertCall.data.error
                }else{
                    precertified = precertCall.data.precertified;
                }
            }
            
        } catch (error) {
            console.log("Error retrieving offer", error);
            precheckError = "Error checking precertification: " + error;

        } finally {
            loading = false;
        }
    }

    function logout() {
        if (auth.currentUser) {
            auth.signOut().then(() => {d("done"); d("logout")}).catch(e => {
                throw new Error(e)
            });
        }
    }

async function waitForClaims(){
    err = "";
    var customClaims: firebase.default.auth.IdTokenResult;
    customClaims = await auth.currentUser.getIdTokenResult(true);
    console.log(customClaims.claims);
    if(!customClaims.claims.hasOwnProperty("role")){
        console.log("trying...")
        var tryCount = 0;
        while(!customClaims.claims.hasOwnProperty("role") && tryCount < 8){
            customClaims = await auth.currentUser.getIdTokenResult(true);
            console.log("Claims: ", customClaims.claims)
            if(customClaims.claims.hasOwnProperty("role") && customClaims.claims.role >= 1){
                d("auth");
                d("done");
                return;
            }else{
                if(customClaims.claims.hasOwnProperty("role") && customClaims.claims.role <= 1){
                    err = "This email is not authorized."
                    return;
                } else {
                    await sleep(1000 + (tryCount * 1000));
                }
            }
            tryCount += 1;
        }
        err = "There was a problem retrieving your authorization. Please refresh and try again.\n If the problem persists, email me at ggaabe@gmail.com";
    } else{
        if(customClaims.claims.hasOwnProperty("role") && customClaims.claims.role >= 1){
            d("auth");
            d("done");
            return;
        }
    }
}
</script>

<div class="sm:w-full md:w-4/12 lg:w1/2" style="margin: 1rem auto">
    {#if !isAuthenticated}
    <div class="w3-container">
        <h2 class="w3-center">{authMode === "login" ? "Login to" : "Register with"} PersuAId</h2>
    </div>
    <div class="w3-container">
        <div class="flex flex-wrap -mx-2 overflow-hidden">
            <button on:click={() => authMode = "login"} class="
                py-2
                my-2 px-2 w-full overflow-hidden md:w-1/2 lg:w-1/2 xl:w-1/2
                rounded
                {authMode === "login" ? "bg-third text-white" : 
                "hover:bg-blue-500 hover:text-white border-2 border-black"}">LOGIN</button>
            <button on:click={() => authMode = "register"} class="
                py-2 
                my-2 px-2 w-full overflow-hidden md:w-1/2 lg:w-1/2 xl:w-1/2
                rounded
                {authMode === "register" ? "bg-third text-white" : 
                "hover:bg-blue-500 hover:text-white border-2 border-black"}">REGISTER</button>
        </div>
        <!-- Email login/register forms -->
        {#if authMode === "login"}
            <form class="border-black border-2 rounded p-2" in:fade on:submit|preventDefault={login}>
                {#if err}
                <ErrorAlert message={err} />
                {/if}
                <h4>Login</h4>
                <div class="flex flex-wrap overflow-hidden lg:-mx-2 ">
                    <div class="w-full overflow-hidden md:w-1/3 lg:my-2 lg:px-2 lg:w-1/3 xl:w-1/3">
                        <label class=" float-right" for="l-email">Email</label>
                    </div>
                    <div class="w-full overflow-hidden md:w-1/2 lg:my-2 lg:px-2 lg:w-1/2 xl:w-1/2">
                        <input 
                        autocomplete="email"
                        type="email" 
                        placeholder="Enter your email" 
                        id="l-email">
                    </div>
                    <div class="w-full overflow-hidden md:w-1/3 lg:my-2 lg:px-2 lg:w-1/3 xl:w-1/3">
                        <label class=" float-right" for="l-password">Password</label>
                    </div>
                    <div class="w-full overflow-hidden md:w-1/2 lg:my-2 lg:px-2 lg:w-1/2 xl:w-1/2">
                        <input 
                        type="password" 
                        placeholder="Enter your password" 
                        id="l-password"
                        autocomplete="current-password">
                    </div>
                </div>
                <div class="flex flex-wrap overflow-hidden lg:-mx-2">
                    <button type="submit" class="w-1/2 mx-auto rounded py-2 text-2xl overflow-hidden
                    bg-third text-white hover:bg-blue-500
                    disabled:opacity-50 
                    {loading ? 'pointer-events-none' : ''}"
                    disabled={loading}>
                    Login
                    </button>
                </div>
                <br/>
                 <div class="flex flex-wrap overflow-hidden w-full">
                    <button on:click={google}>
                        <i class="fab fa-google"></i> 
                        Sign in with Google
                    </button>
                </div>
                <!-- <button on:click={() => authMode = "register"} type="button" class="w-full overflow-hidden md:w-1/2 lg:my-2 lg:px-2 lg:w-1/2 xl:w-1/2
                 rounded border-black border-2">Register</button> -->
            </form>
        {:else}
        {#if true}
        <form
        class="border-black border-2 rounded p-2"
         in:slide|local on:submit|preventDefault={register}>
            {#if err}
            <ErrorAlert message={err} />
            {/if}
            <h4>Register</h4>
            <p>
                <label for="r-email">Email</label>
                <input 
                type="email"
                disabled={precertified}
                bind:value={precertEmail}
                class="w3-input w3-border" 
                placeholder="Enter your email" 
                id="r-email"
                autocomplete="email">
            </p>
            <p>
                <label for="r-password">Password</label>
                <input type="password" 
                class="w3-input w3-border" 
                placeholder="Enter a password" 
                id="r-password">
            </p>
            <p>
                <label for="r-cpassword">Confirm Password</label>
                <input type="password" class="w3-input w3-border" placeholder="Re-enter that password" id="r-cpassword">
            </p>
            <div class="flex flex-wrap overflow-hidden lg:-mx-2 mt-2">
                <button type="submit" class="w-1/2 mx-auto rounded py-2 text-2xl overflow-hidden
                bg-third text-white hover:bg-blue-500 disabled:opacity-50 
                {loading ? 'pointer-events-none' : ''}"
                disabled={loading}
                >
                    Register
                </button>
            </div>
                <!-- <button on:click={() => authMode = "login"} type="button" class="w3-button w3-light-gray">Login</button> -->
            <br/><br/>
            <div class="flex flex-wrap overflow-hidden">
                <button class="w-full" style="width: 100%" on:click={google}><i class="fab fa-google"></i> Sign in with Google</button>
            </div>
        </form>
        {:else}
        <form on:submit|preventDefault={checkPrecertification}>
            <!-- <h4>Precertification</h4>

            {#if precheckError}
            <ErrorAlert message={precheckError} />
            {/if}
            <p>
                <label for="check-email">PeruAId is only available for select users. Please enter your email to confirm you are certified.</label>
                <input
                bind:value={precertEmail}
                type="email"
                name="check-email" 
                class="w3-input w3-border" 
                placeholder="Enter your email" 
                id="check-email"
                autocomplete="email">
            </p>

            <div class="flex flex-wrap overflow-hidden lg:-mx-2 mt-2">
                <button type="submit"
                class="w-1/2 mx-auto rounded py-2 text-2xl overflow-hidden
                bg-third text-white hover:bg-blue-500
                disabled:opacity-50 {loading ? 'pointer-events-none' : ''}"
                disabled={loading}>
                    Confirm
                </button>
            </div> -->
        </form>
        {/if}

        {/if}
        <hr>

    </div>
    {:else}
    <div class="w-full justify-center items-center">
        <div class="flex justify-self-center items-center w-full justify-center flex-col">
            <div class="justify-self-center justify-center">
                <i class="fas fa-check fa-5x"></i>
            </div>
            <div class="w3-center">Logged in, redirecting... 
                {#if isRegister}
                    <p>Your first sign-in may take a few moments while we prepare your account.</p>
                {/if}
            </div>
            <p class="text-red-500">{err}</p>
        </div>
    </div>
    {/if}
</div>

<style>
input{
    width: 95%;
    @apply border-black;
    @apply rounded;
    @apply border-2;
    display: block;
}
</style>